import { Text } from "@clipboard-health/ui-components";
import { Stack, useTheme } from "@mui/material";

interface InstantPaySummaryProps {
  totalPay: number;
}

export function InstantPaySummary(props: InstantPaySummaryProps) {
  const { totalPay } = props;
  const theme = useTheme();

  const eligibleAmount = totalPay * 0.6;

  if (totalPay <= 0) {
    return (
      <Text variant="body1" sx={{ color: theme.palette.text.secondary }}>
        Fill out the form above to calculate your eligible amount
      </Text>
    );
  }

  return (
    <Stack spacing={1.5}>
      <Text variant="body1" sx={{ color: theme.palette.text.secondary }}>
        You are eligible to receive{" "}
        <Text semibold variant="body1" sx={{ display: "inline" }}>
          ${eligibleAmount.toFixed(2)}
        </Text>{" "}
        of your ${totalPay.toFixed(2)} pay
      </Text>
      <Text variant="body1" sx={{ color: theme.palette.text.secondary, pt: 3 }}>
        How much cash you want?
      </Text>
    </Stack>
  );
}
